var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4C12.76 4 8.5 8.26 8.5 13.5C8.5 18.64 12.52 22.8 17.76 22.98C17.92 22.96 18.08 22.96 18.2 22.98C18.24 22.98 18.26 22.98 18.3 22.98C18.32 22.98 18.32 22.98 18.34 22.98C23.46 22.8 27.48 18.64 27.5 13.5C27.5 8.26 23.24 4 18 4Z",
    fill: "#CED1DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1599 28.3C22.5799 24.58 13.4799 24.58 7.85992 28.3C5.31992 30 3.91992 32.3 3.91992 34.76C3.91992 37.22 5.31992 39.5 7.83992 41.18C10.6399 43.06 14.3199 44 17.9999 44C21.6799 44 25.3599 43.06 28.1599 41.18C30.6799 39.48 32.0799 37.2 32.0799 34.72C32.0599 32.26 30.6799 29.98 28.1599 28.3Z",
    fill: "#CED1DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9802 14.68C40.3002 18.56 37.5402 21.96 33.7202 22.42C33.7002 22.42 33.7002 22.42 33.6802 22.42H33.6202C33.5002 22.42 33.3802 22.42 33.2802 22.46C31.3402 22.56 29.5602 21.94 28.2202 20.8C30.2802 18.96 31.4602 16.2 31.2202 13.2C31.0802 11.58 30.5202 10.1 29.6802 8.84002C30.4402 8.46002 31.3202 8.22002 32.2202 8.14002C36.1402 7.80002 39.6402 10.72 39.9802 14.68Z",
    fill: "#CED1DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.98 33.18C43.82 35.12 42.58 36.8 40.5 37.94C38.5 39.04 35.98 39.56 33.48 39.5C34.92 38.2 35.76 36.58 35.92 34.86C36.12 32.38 34.94 30 32.58 28.1C31.24 27.04 29.68 26.2 27.98 25.58C32.4 24.3 37.96 25.16 41.38 27.92C43.22 29.4 44.16 31.26 43.98 33.18Z",
    fill: "#CED1DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIcon);
export default __webpack_public_path__ + "static/media/ClientsIcon.2f74d238d7b72eb5512e1c158555ff40.svg";
export { ForwardRef as ReactComponent };